import { AuthState, TWPERMISSIONS } from 'dataSource/auth/types'
import { createContext, ReactNode, useReducer } from 'react'

const AuthInitial = {
  isAuthenticated: false,
  isLoading: true,
  permissions: [],
}

type LoginAction = {
  type: 'LOGIN'
  payload?: {
    permissions: TWPERMISSIONS[]
  }
}

type LogoutAction = {
  type: 'LOGOUT'
}
type SetAnonymousAction = {
  type: 'SET_ANONYMOUS'
}
type AuthActions = LoginAction | SetAnonymousAction | LogoutAction

export const AuthContext = createContext<
  [AuthState, React.Dispatch<AuthActions>]
>(null)

export const loginUserAction = (permissions: TWPERMISSIONS[]): LoginAction => ({
  type: 'LOGIN',
  payload: {
    permissions,
  },
})

export const logoutUserAction = (): LogoutAction => ({
  type: 'LOGOUT',
})

export const setAnonymousAction = (): SetAnonymousAction => ({
  type: 'SET_ANONYMOUS',
})

const reducer = (state, action) => {
  const { payload } = action

  switch (action.type) {
    case 'LOGIN':
      return {
        ...state,
        isAuthenticated: true,
        isLoading: false,
        permissions: payload.permissions,
      }
    case 'SET_ANONYMOUS':
      return {
        ...AuthInitial,
        isLoading: false,
      }
    case 'LOGOUT':
      return {
        ...AuthInitial,
        isLoading: false,
      }
    default:
      return state
  }
}

const AuthContextWrapper = ({
  children,
}: {
  children: ReactNode
}): JSX.Element => {
  const authReducer = useReducer(reducer, AuthInitial)
  return (
    <AuthContext.Provider value={authReducer}>{children}</AuthContext.Provider>
  )
}

export default AuthContextWrapper
